import InputMask from 'react-input-mask';
import styled from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

import { ComponentProps as InputProps } from './Input';

/**
 * Main container layout
 */
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: stretch;
  max-width: 350px;
  width: 100%;

  @media ${device.isMobile} {
    max-width: none;
  }
`;

/**
 * Label element
 */
export const Label = styled.label`
  align-self: stretch;
  height: 24px;
  font-weight: 600;
  overflow-wrap: break-word;
  color: ${colors.blueGrey};
`;

export const Small = styled.small`
  color: ${colors.red};
  display: block;
  font-size: 1rem;
  position: relative;
`;

export const StyledInput = styled(InputMask)<InputProps & { isError: boolean }>`
  align-self: stretch;
  text-align: left;
  width: ${props => {
    switch (props.mode) {
      case 'FullDate':
        return '115px';
      case 'MonthYear':
        return '80px';
      case 'MonthYearShort':
        return '60px';
    }
  }};
  height: 46px;
  border-radius: 2px;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5rem;
  letter-spacing: -0.32px;
  outline: 0px !important;
  color: ${colors.blueGrey75};
  border: solid 1px ${props => (props.isError ? colors.red : colors.blueGrey)};
  background-color: ${props => (props.disabled ? colors.darkGrey10 : colors.white)};
  padding: 0 16px;
  margin: 8px 0;

  ${props =>
    props.disabled
      ? ' cursor: not-allowed;'
      : `:active,
  :focus {
    border: solid 1px ${props.isError ? colors.red : colors.orange};
    color: ${colors.blueGrey};
    background-color: transparent;
  }`};

  :placeholder {
    color: ${colors.blueGrey75};
  }
`;
